import * as Actions from 'app/store/actions';

const initialState = { data: null };

const adminOnFarmEstimateReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ADMIN_ON_FARM_ESTIMATE_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default adminOnFarmEstimateReducer;
